import { makeT } from "@lana-commerce/core/react/translateLocalStatic";

// prettier-ignore
export const T = makeT({
  ru: {
    Clear: "Сброс",
  },
});
